module.exports = __webpack_public_path__ + "static/media/icon__before-after.5556791e.svg";